export const productCategory = [
    {
        src: require("@/assets/images/products_page/p_knight4cf.jpg"),
        name: 'NEW RELEASED',
        id: 'category-new',
        desc: 'Here you can find unique products and open a new blue ocean market together with Scan Top.',
        items: [
            { name: 'Knight 4-CF', to: { name: 'product', params: { name: 'knight4cf' } } },
            { name: 'W6 (Beam type)', to: { name: 'product', params: { name: 'w6' } } },
            { name: 'SQ4M', to: { name: 'product', params: { name: 'sq4m' } } },
            { name: 'UR3 (Beam Design)', to: { name: 'product', params: { name: 'ur3' } } },
            { name: 'SQ5M', to: { name: 'product', params: { name: 'sq5m' } } },
            { name: 'SQ6M (Double Flexor)', to: { name: 'product', params: { name: 'sq6m' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_traditional.jpg"),
        name: 'CONVENTIONAL WIPER BLADE',
        id: 'category-conventional',
        desc: 'Traditional Wiper Blade is the most economical and optimal type with easy-installed adapter, stable wiping performance and broad market coverage.',
        items: [
            { name: 'SUPER', to: { name: 'product', params: { name: '_super' } } },
            { name: 'PREMIUM', to: { name: 'product', params: { name: 'premium' } } },
            { name: 'EXCLUSIVE (Multi-Functional)', to: { name: 'product', params: { name: 'exclusive' } } },
            { name: 'FREEWAVE 1', to: { name: 'product', params: { name: 'freewave1' } } },
            { name: 'FREEWAVE 2', to: { name: 'product', params: { name: 'freewave2' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_snow.jpg"),
        name: 'SNOW (Multi-Functional)',
        id: 'category-snow',
        desc: 'The Snow Wiper Blade is an indispensable product for the northern countries, it can guarantee the safety of driving in the snow.',
        items: [
            { name: 'W4 (Conventional type)', to: { name: 'product', params: { name: 'w4' } } },
            { name: 'W6 (Beam type)', to: { name: 'product', params: { name: 'w6' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_beam.jpg"),
        name: 'BEAM WIPER BLADE',
        id: 'category-beam',
        desc: 'Beam type design helps to keep the wiper blades in closer contact with the windshield so as to prevent it from wind lifting or juddering during high speed.',
        items: [
            { name: 'SQ4D (Double Flexor)', to: { name: 'product', params: { name: 'sq4d' } } },
            { name: 'SQ4M', to: { name: 'product', params: { name: 'sq4m' } } },
            { name: 'SQ5D (Single Flexor)', to: { name: 'product', params: { name: 'sq5d' } } },
            { name: 'SQ5M', to: { name: 'product', params: { name: 'sq5m' } } },
            { name: 'SQ6M (Double Flexor)', to: { name: 'product', params: { name: 'sq6m' } } },
            { name: 'KNIGHT 3', to: { name: 'product', params: { name: 'knight3' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_hybrid.jpg"),
        name: 'HYBRID WIPER BLADE',
        id: 'category-hybrid',
        desc: 'Hybrid Wiper Blade combines the advantages of traditional wiper blade and flat wiper blade with patented multi-functional adapter base. Experience a superior wiping performance of Hybrid Wiper Blade with Scan Top.',
        items: [
            { name: 'KNIGHT 4', to: { name: 'product', params: { name: 'knight4' } } },
            { name: 'Knight 4-CF', to: { name: 'product', params: { name: 'knight4cf' } } },
            { name: 'JET 5', to: { name: 'product', params: { name: 'jet5' } } },
            { name: 'JET 6 (Hook Type Only)', to: { name: 'product', params: { name: 'jet6' } } },
            { name: 'NEW AGE', to: { name: 'product', params: { name: 'new_age' } } },
            { name: 'Wiper-X (Brand Exclusive)', to: { name: 'product', params: { name: 'wiperx' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_heavyduty.jpg"),
        name: 'HEAVYDUTY WIPER BLADE',
        id: 'category-heavyduty',
        desc: 'Our Heavyduty Wiper Blade has the stainless steel backing and Galvanized Zinc steel frames, especially for European truck and bus.',
        items: [
            { name: 'TRUCK', to: { name: 'product', params: { name: 'truck' } } },
            { name: 'BUS', to: { name: 'product', params: { name: 'bus' } } },
        ]
    },
    {
        src: require("@/assets/images/products_page/p_rear.jpg"),
        name: 'REAR WIPER BLADE',
        id: 'category-rear',
        desc: 'To increase further convenience, Scan Top provides technology rear wiper blades which ensure clearer rear-view visibility. Offering two kinds of designs: Traditional type and Hybrid type, both of them have patented multi-functional mounting base and easy-fit adapters, thereby adding the range coverage of the vehicle types.',
        items: [
            { name: 'Ultra 1 (Conventional)', to: { name: 'product', params: { name: 'ultra_1' } } },
            { name: 'Ultra 2 (Hybrid Design)', to: { name: 'product', params: { name: 'ultra_2' } } },
            { name: 'UR3 (Beam Design)', to: { name: 'product', params: { name: 'ur3' } } },
        ]
    },
    {
        src: '',
        name: 'SUPPLIES',
        id: 'category-supplies',
        desc: '',
        items: [
            { name: 'Refill', to: { name: 'product', params: { name: 'refill' } } },
        ]
    }
]